package site.shadadman.pages.worklog.SportsGameX

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initJun122025SportsGameXKMPIntegrationPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("worklog/SportsGameX/jun122025SportsGameXKMPIntegration.md", FrontMatterElement.EmptyMap))
}

@Page("/worklog/SportsGameX/jun122025-sports-game-xkmp-integration")
@Composable
fun Jun122025SportsGameXKMPIntegrationPage() {
    org.jetbrains.compose.web.dom.H2(attrs = { id("may-12-2025-sportsgamex-kmp-integration") }) {
        org.jetbrains.compose.web.dom.Text("may-12-2025-sportsgamex-KMP-Integration")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("I got a new and interesting responsibility. Implementing KMP modules to be shared between ios and android source code. This modules will hold common logics that can be shared between both platform.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("After a couple of meetings with the team leads, I explained why these modules could be a huge help and how we planned to use them. Both the Android and iOS teams were happy about it. These modules can lift a weight off their shoulders.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We had a couple of features that can be implemented with this modules:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Google sign in")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Analyzer platforms, Firebase and mixpannel")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("TradingView charts")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The implementation of these features was repetitive work on both mobile platforms. Now, instead of having the team develop them again, they can focus on new features.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("I became responsible not only for developing these features but also for implementing their CI/CD pipelines and injecting them into both of our mobile platforms.")
    }
}
